module.exports = __webpack_public_path__ + "static/media/banesco-pin.7035e021.svg";